jQuery(document).ready(function($) {

    // Set age verification variables variables
    var cvcookie  = JSON.parse(localStorage.getItem('cv-verification'));
    var cvbanner  = $('.cv-verification');
    var cvdismiss = $('.cv-toggle');
    var cvnow     = Math.floor(Date.now() / 1000);

    // Banner has expired
    if (cvcookie !== null && cvnow > cvcookie.expiry) {
        localStorage.setItem("cv-verification", null);
        cvcookie = null;
    }

    // Show banner
    if (cvcookie === null) {
        cvbanner.addClass('active');
    }

    cvdismiss.click(function(e) {
        e.preventDefault();

        // add 24 hours
        localStorage.setItem('cv-verification', JSON.stringify({
            expiry: cvnow + (60 * 60 * 24),
        }));

        cvbanner.removeClass('active');
    });

    /**
     * Adding CSS class to uneditable elements
     *
     */
    jQuery(".avatar").addClass("media-object");

    /**
     * Triggering the WP gallery modal
     *
     */
    // This is need to prevent click event spam on the modal
    var blnModalOpen = false;
    jQuery(".gallery-item").on("click", function() {
        var strAltText = jQuery(this).find("img").attr("alt");
        var strDataImage = jQuery(this).find("img").data("image");
        var intCurrentItem = jQuery(this).closest(".gallery").children().index(jQuery(this)) + 1;
        var intTotalItems = jQuery(this).closest(".gallery").find('.gallery-item').length + 1;
        var strOutput = "";

        // Set the content of the modal
        strOutput += '<img src="' + strDataImage + '" class="img-responsive" alt="' + strAltText + '"/>';
        strOutput += '<div class="caption"><p>' + strAltText + '</p></div>';
        strOutput += '<a class="controls next" href="' + (intCurrentItem + 1) + '"><span class="glyphicon glyphicon-chevron-right"></span> <span class="sr-only">Next Slide</span></a>';
        strOutput += '<a class="controls previous" href="' + (intCurrentItem - 1) + '"><span class="glyphicon glyphicon-chevron-left"></span> <span class="sr-only">Previous Slide</span></a>';

        // Set modal content
        jQuery("#chimera_gallery_modal .modal-body").html(strOutput);

        // Hide the next button on last image
        if (intTotalItems === parseInt(intCurrentItem) + 1) {
            jQuery("#chimera_gallery_modal a.next").hide();
        }

        // Hide prev button on first image
        if (intCurrentItem === 1) {
            jQuery("#chimera_gallery_modal a.previous").hide();
        }

        // Check to see if there are any modals open
        // if not open our new modal and add the active class
        if (!blnModalOpen) {
            jQuery(this).closest('.gallery').addClass('active');
            jQuery("#chimera_gallery_modal").modal();
            blnModalOpen = true;
        }
    });

    /**
     * Listening for the close event so we can remove the content
     *
     */
    jQuery("#chimera_gallery_modal").on("hidden.bs.modal", function(event) {
        // Remove active gallery class and delete modal content
        jQuery('.gallery.active').removeClass('active');
        jQuery("#chimera_gallery_modal .modal-body").html("");
        blnModalOpen = false;
    });

    /**
     * Change iframe src on video gallery thumbnail click
     *
     */
    jQuery(".youtube-thumbnails a").on('click', function(event) {
        event.preventDefault();
        var objLargeVideo = jQuery("#large-video");
        var strLargeSrc = objLargeVideo.attr("src");
        var strThumbSrc = jQuery(this).attr("href");

        objLargeVideo.attr("src", strThumbSrc);
        strLargeSrc = strThumbSrc;
    });

    /**
     * Archive AJAX infinite scrolling
     *
     */
    var objAjaxScroll = {
        strTargetInit: '.ajax-scroll-init',
        strTargetLoadingIcon: '.ajax-scroll-loading-icon',
        strTargetContent: '.ajax-scroll-content',
        intScrollTopLast: 0,
        blnLoading: false,
        blnPageMax: false,
        intPage: 1,

        init: function() {
            var objThis = this;

            // Start the infinite scroll
            $(objThis.strTargetInit).on('click', function() {
                // Hide the init button
                $(this).addClass('hidden');

                // Load the first results
                objThis.load();
            });

            // Add a scroll event that checks the scroll distance
            $(window).on('scroll', function() {
                // First page results are loaded by the click event
                if (objThis.intPage === 1 || objThis.blnPageMax || objThis.blnLoading) {
                    return;
                }

                // Load results after the click event
                objThis.checkScrollDistance();
            });
        },

        /**
         * Check the scroll distance to trigger the load
         *
         */
        checkScrollDistance: function() {
            var objThis = this;

            // Set the scroll top and bottom of the window
            var intScrollTop = $(window).scrollTop();
            var intScrollBottom = $(window).scrollTop() + $(window).height();

            // Set the point at which the load triggers
            var intContentBottom = $(objThis.strTargetContent).offset().top + ($(objThis.strTargetContent).height() / 3);

            // If scrolling down and scrolled past the trigger point
            if (intScrollTop > objThis.intScrollTopLast && intScrollBottom >= intContentBottom) {
                objThis.load();
            }

            // Update the last scroll top
            objThis.intScrollTopLast = intScrollTop;
        },

        /**
         * Gets gets the post data and markup
         *
         */
        load: function() {
            var objThis = this;

            // Set load state
            objThis.blnLoading = true;

            // Show loading icon
            $(objThis.strTargetLoadingIcon).addClass('active');

            // Data being sent
            var objData = {
                action: 'ajax_scroll_load',
                url: objChimeraData.url,
                query: objChimeraData.query,
                query_vars: objChimeraData.query_vars,
                page: objThis.intPage,
            };

            // Send the AJAX call
            $.getJSON(objChimeraData.ajaxurl, objData, function(objResponse) {
                // Check that the response isn't null
                if (typeof objResponse === null) {
                    console.log('Error: unexpected response');
                    objThis.blnLoading = false;
                    return;
                }

                // Set response variables
                var blnError = (typeof objResponse.error !== 'undefined') ? objResponse.error : false;
                var strMessage = (typeof objResponse.message !== 'undefined') ? objResponse.message : '';
                var strHtml = (typeof objResponse.html !== 'undefined') ? objResponse.html : '';
                var strPage = (typeof objResponse.page !== 'undefined') ? objResponse.page : '';
                var blnPageMax = (typeof objResponse.page_max !== 'undefined') ? objResponse.page_max : false;

                // Set the html
                if (strHtml.length > 0) {
                    $(objThis.strTargetContent).append(strHtml);
                }

                // Increment the page
                if (strPage.length !== '') {
                    objThis.intPage = strPage;
                }

                // We've hit our max page and should stop loading
                if (blnPageMax === true) {
                    objThis.blnPageMax = true;
                }

                // Hide loading icon
                $(objThis.strTargetLoadingIcon).removeClass('active');

                // End load state
                objThis.blnLoading = false;

                // Fire a custom event
                $('body').trigger('ajax_scroll_load_done', [{
                    'html': strHtml,
                }]);
            });
        }

    }; // end objAjaxScroll

    // Init the infinite scrolling
    objAjaxScroll.init();

});


/**
 * Delegated function for changing the gallery image on
 *
 */
jQuery(document).on("click", "#chimera_gallery_modal a.controls", function () {
    var intCurrentItem = parseInt(jQuery(this).attr("href"));
    var intPreviousItem = parseInt(intCurrentItem) - 1;
    var intNextItem = parseInt(intCurrentItem) + 1;
    var intTotalItems = jQuery(".gallery.active .gallery-item").length + 1;

    var objCurrentImage = jQuery(".gallery.active .gallery-item:nth-child(" + intCurrentItem + ") img");
    var strDataImage = objCurrentImage.data("image");
    var strAltText = objCurrentImage.attr("alt");
    var objGalleryImage = jQuery("#chimera_gallery_modal img");

    objGalleryImage.attr("src", strDataImage);
    objGalleryImage.attr("alt", strAltText);
    jQuery("#chimera_gallery_modal p").html(strAltText);

    if (jQuery(this).hasClass("previous")) {
        jQuery(this).attr("href", intPreviousItem);
        jQuery("#chimera_gallery_modal a.next").attr("href", intNextItem);
    } else {
        jQuery(this).attr("href", intNextItem);
        jQuery("#chimera_gallery_modal a.previous").attr("href", intPreviousItem);
    }

    // Show or hide the next button
    if (intTotalItems === intNextItem) {
        jQuery("#chimera_gallery_modal a.next").hide();
    } else {
        jQuery("#chimera_gallery_modal a.next").show();
    }

    // Show or hide the previous button
    if (intPreviousItem === 0) {
        jQuery("#chimera_gallery_modal a.previous").hide();
    } else {
        jQuery("#chimera_gallery_modal a.previous").show();
    }
    return false;
});

if ("standalone" in window.navigator && window.navigator.standalone) {
    var noddy, remotes = false;
    document.addEventListener("click", function (e) {
        noddy = e.target;
        while (noddy.nodeName !== "A" && noddy.nodeName !== "HTML") {
            noddy = noddy.parentNode;
        }
        if ("href" in noddy && noddy.href.indexOf("http") !== -1 && (noddy.href.indexOf(document.location.host) !== -1 || remotes)) {
            e.preventDefault();
            document.location.href = noddy.href;
        }
    }, false);
}

/**
 * Detects the screen size
 *
 */
function isSize(strSize) {
    // Out objects
    var objSizes = {
        xs: $('.js-detect-xs').is(':visible'),
        sm: $('.js-detect-sm').is(':visible'),
        md: $('.js-detect-md').is(':visible'),
        lg: $('.js-detect-lg').is(':visible'),
    }

    // Return the size
    return objSizes[strSize];
}

/**
 * Enabled :active css states on mobile devices
 *
 */
document.addEventListener('touchstart', function() {}, false);
